var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avg-readiness-banner"},[_c('div',{staticClass:"readiness-bar-title"},[_vm._v("AVG Readiness")]),_c('div',{staticClass:"custom-readiness-bar"},[_c('ReadinessBar',{attrs:{"barValue":_vm.validatedReadiness,"maxValue":150,"type":"readiness"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }